import {
  getContactDetails,
  getHumanName,
  parseToISOString,
} from '@ctw/shared/content/CCDA/ccda-viewer/helpers';
import {
  type ExtendedGeneralInfo,
  isExtendedGeneralInfoExist,
} from '@ctw/shared/content/CCDA/ccda-viewer/types';
import { isEmpty } from 'lodash-es';
import xpath from 'xpath';

export const getAuthenticatorData = (
  document: Document,
): Array<ExtendedGeneralInfo> | undefined => {
  const authenticators = xpath.select(
    "*[name()='ClinicalDocument']/*[name()='authenticator']",
    document,
  ) as Array<Document>;
  if (isEmpty(authenticators)) {
    return undefined;
  }
  return authenticators
    .map((authenticator): ExtendedGeneralInfo | undefined => {
      const assignedEntity = xpath.select1("*[name()='assignedEntity']", authenticator) as
        | Document
        | undefined;
      if (!assignedEntity) {
        return undefined;
      }
      const assignedPerson = xpath.select1(
        "*[name()='assignedPerson']",
        assignedEntity,
      ) as Document;
      const name = getHumanName(
        xpath.select("*[name()='name']", assignedPerson) as Array<Document>,
      );
      const contactDetails = getContactDetails(
        xpath.select("*[name()='addr']", assignedEntity) as Array<Document>,
        xpath.select("*[name()='telecom']", assignedEntity) as Array<Document>,
      );

      const time = parseToISOString(
        String(xpath.select1("string(*[name()='time']/@value)", authenticator)),
      );
      return { name, contactDetails, time };
    })
    .filter(isExtendedGeneralInfoExist);
};
